import { render } from "./FormEditor.vue?vue&type=template&id=21b8d9a4&scoped=true&ts=true"
import script from "./FormEditor.vue?vue&type=script&lang=ts"
export * from "./FormEditor.vue?vue&type=script&lang=ts"

import "./FormEditor.vue?vue&type=style&index=0&id=21b8d9a4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b8d9a4"]])

export default __exports__